import { withStyles } from '@material-ui/core/styles';
import DoneIcon from '@material-ui/icons/Done';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles } from '../style/gstheme';
import { PROJECT_COLOURS } from '../utils/constants';

const styles = () => {
  return Object.assign({
    colourBlock: {
      float: 'left',
      marginRight: '8px',
      marginBottom: '8px',
      textAlign: 'center',
      width: '46px',
      height: '30px',
      borderRadius: '4px',
      '&:hover': {
        cursor: 'pointer'
      }
    },
    inactiveColourBlock: {
      float: 'left',
      marginRight: '8px',
      marginBottom: '8px',
      textAlign: 'center',
      width: '46px',
      height: '30px',
      borderRadius: '4px'
    }
  }, globalStyles);
};

class ProjectColour extends React.Component {

  render() {

    const { colour, handleChangeColour, classes, isReadOnly } = this.props;

    return (
      <div data-test="project-colours" style={{ overflow: 'auto' }}>
        {PROJECT_COLOURS.map((option, index) =>
          <div data-test={"project-colour-" + index}
            key={index}
            onClick={!isReadOnly ? () => handleChangeColour(option) : null}
            className={isReadOnly ? classes.inactiveColourBlock : classes.colourBlock}
            style={{
              backgroundColor: '#' + option
            }}>
            {option === colour && <DoneIcon data-test="selected-colour" fontSize="small" style={{ color: 'white', paddingTop: '5px' }} />}
          </div>
        )}
      </div>
    );
  }
}

ProjectColour.defaultProps = {
  colour: "13294B",
  isReadOnly: true
};

ProjectColour.propTypes = {
  classes: PropTypes.object,
  colour: PropTypes.string,
  isReadOnly: PropTypes.bool,
  handleChangeColour: PropTypes.func.isRequired
};

export default withStyles(styles)(ProjectColour);